import React from "react";
import {Link as RouterLink} from "react-router-dom";
import {Box, Heading, Image, Text} from "@chakra-ui/react";
import {ArrowForwardIcon} from "@chakra-ui/icons";
import {categoryCover, categoryUrl, imageUrl, photoCount} from "../data/catalog";

const plural = (n, word) => `${n} ${word}${n === 1 ? "" : "s"}`;

function CategoryTile({category, h = {base: "240px", md: "320px"}, compact = false, ...rest}) {
    return (
        <Box as={RouterLink} to={categoryUrl(category)} data-group position="relative" display="block" overflow="hidden"
             h={h} bg="ink.900" {...rest}>
            <Image src={imageUrl(categoryCover(category))} alt={category.title} loading="lazy"
                   position="absolute" inset={0} w="100%" h="100%" objectFit="cover"
                   transition="transform 0.6s ease" _groupHover={{transform: "scale(1.06)"}}/>
            <Box position="absolute" inset={0}
                 bgImage="linear-gradient(to top, rgba(0,0,0,0.82) 0%, rgba(0,0,0,0.2) 55%, rgba(0,0,0,0) 100%)"/>
            <Box position="absolute" left={0} right={0} bottom={0} p={compact ? 4 : {base: 5, md: 6}} color="white">
                {!compact && (
                    <Text fontSize="xs" letterSpacing="0.14em" textTransform="uppercase" color="whiteAlpha.800">
                        {plural(category.content.length, "style")} · {plural(photoCount(category), "photo")}
                    </Text>
                )}
                <Heading as="h3" color="white" fontSize={compact ? "md" : {base: "lg", md: "xl"}} textTransform="uppercase"
                         letterSpacing="0.03em" lineHeight={1.2} mt={1}>
                    {category.title}
                </Heading>
                {!compact && (
                    <Text as="span" mt={4} fontSize="xs" fontWeight={700} letterSpacing="0.14em" textTransform="uppercase"
                          display="inline-flex" alignItems="center" gap={2} borderBottom="2px solid" borderColor="brand.500" pb={1}>
                        View more
                        <ArrowForwardIcon transition="transform 0.2s" _groupHover={{transform: "translateX(4px)"}}/>
                    </Text>
                )}
            </Box>
        </Box>
    );
}

export default CategoryTile;
